import { module } from 'angular';
import component from './recorder-ui.component';

export default module('app.recorder-ui', [])
	.component('recorderUi', component)
	.name;
